import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'rp-react-svg-icon';

function ShortlistTableActions({ selectedRows, onRowDelete }) {
    const isDisabled = selectedRows.length === 0;
    const className = classnames(
        'ui-btn',
        'ui-btn_primary',
        'shortlistTableActions__button',
        'shortlistTableActions__button_delete',
        {
            shortlistTableActions__button_disabled: isDisabled
        }
    );
    return (
        <div className="shortlistTableActions">
            <button
                type="button"
                className={className}
                onClick={onRowDelete}
                disabled={isDisabled}
            >
                <Svg iconName="bin" size="Medium" className="shortlistTableActions__icon" />
            </button>
        </div>
    );
}

ShortlistTableActions.propTypes = {
    selectedRows: PropTypes.array.isRequired,
    onRowDelete: PropTypes.func.isRequired
};

export default ShortlistTableActions;



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistTableActions.js